import { forwardRef } from 'react';
import { css } from '@emotion/react';
import { CaretDownIconSmall } from '../../../icon';
import { ActionPressedChip, ActionPressedChipProps } from './action-pressed-chip';

type ActionDropdownChip = Omit<ActionPressedChipProps, 'endIcon'> & {
  isOpen?: boolean;
  showCaret?: boolean;
};

const chevronAnimatedStyle = (isActive: boolean) => css`
  transition: transform 300ms ease-out;
  display: flex;
  flex-direction: center;
  justify-content: center;
  transform: rotate(${isActive ? 180 : 0}deg);
`;

export const ActionDropdownChip = forwardRef<HTMLButtonElement, ActionDropdownChip>(
  ({ isOpen, showCaret = true, children, ...rest }, ref) => {
    return (
      <ActionPressedChip
        ref={ref}
        {...rest}
        endIcon={
          showCaret ? (
            <span className='chevron-arrow' css={chevronAnimatedStyle(!!isOpen)}>
              <CaretDownIconSmall size={8} />
            </span>
          ) : null
        }
      >
        {children}
      </ActionPressedChip>
    );
  }
);

ActionDropdownChip.displayName = 'ActionDropdownChip';
